import React from "react";
import { ArrowRight } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section
      id="contact"
      data-testid="final-cta"
      className="py-20 sm:py-28 bg-lw-ivory"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="relative rounded-3xl overflow-hidden gradient-navy-indigo px-8 sm:px-14 py-14 sm:py-20 text-center">
          {/* Subtle gold flourish */}
          <div
            aria-hidden="true"
            className="absolute -top-24 -right-24 w-[360px] h-[360px] rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(212,162,76,0.22) 0%, rgba(212,162,76,0) 70%)",
            }}
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-24 -left-24 w-[360px] h-[360px] rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(212,162,76,0.14) 0%, rgba(212,162,76,0) 70%)",
            }}
          />

          <div className="relative">
            <span
              className="lw-eyebrow"
              style={{ color: "#D4A24C" }}
            >
              Begin the Conversation
            </span>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#FAF8F3] leading-[1.1]">
              Start with a <span className="italic">no-obligation</span>{" "}
              conversation.
            </h2>
            <p className="mt-5 max-w-xl mx-auto text-base sm:text-lg text-[#FAF8F3]/75 leading-relaxed">
              A 30-minute call with one of our advisors. No paperwork, no
              pressure — just clarity on where you are and what could come
              next.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <a
                href="mailto:info@lifespanwealthpartners.com"
                data-testid="final-cta-button-primary"
                className="btn-gold"
              >
                Book a Conversation <ArrowRight size={18} />
              </a>
              <a
                href="#advisors"
                data-testid="final-cta-button-secondary"
                className="btn-ghost-light"
              >
                Meet the Team
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
